import React, { useState } from 'react';
import Icon from '../AppIcon';


const QuickActionPanel = ({ userRole = 'member', onAction }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const roleQuickActionsMap = {
    member: [
      { id: 'checkin', label: 'Check In', icon: 'QrCode', color: 'primary' },
      { id: 'book-class', label: 'Book Class', icon: 'Calendar', color: 'accent' },
      { id: 'start-workout', label: 'Start Workout', icon: 'Play', color: 'success' },
    ],
    staff: [
      { id: 'manual-checkin', label: 'Manual Check-In', icon: 'UserCheck', color: 'primary' },
      { id: 'add-member', label: 'Add Member', icon: 'UserPlus', color: 'accent' },
      { id: 'emergency', label: 'Emergency', icon: 'AlertTriangle', color: 'error' },
    ],
    trainer: [
      { id: 'start-session', label: 'Start Session', icon: 'Play', color: 'primary' },
      { id: 'view-schedule', label: 'Schedule', icon: 'Calendar', color: 'accent' },
      { id: 'client-notes', label: 'Client Notes', icon: 'FileText', color: 'success' },
    ],
    manager: [
      { id: 'view-analytics', label: 'Analytics', icon: 'BarChart3', color: 'primary' },
      { id: 'staff-schedule', label: 'Staff Schedule', icon: 'Users', color: 'accent' },
      { id: 'reports', label: 'Reports', icon: 'FileText', color: 'success' },
    ],
    owner: [
      { id: 'single-gym-view', label: 'Gym Overview', icon: 'Building', color: 'primary' },
      { id: 'financial-overview', label: 'Financials', icon: 'DollarSign', color: 'accent' },
      { id: 'performance', label: 'Performance', icon: 'TrendingUp', color: 'success' },
    ],
  };

  const quickActions = roleQuickActionsMap?.[userRole] || roleQuickActionsMap?.member;
  const primaryAction = quickActions?.[0];
  const secondaryActions = quickActions?.slice(1);

  const handleActionClick = (actionId) => {
    if (onAction) {
      onAction(actionId);
    }
    setIsExpanded(false);
  };

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
      accent: 'bg-accent text-accent-foreground hover:bg-accent/90',
      success: 'bg-success text-success-foreground hover:bg-success/90',
      error: 'bg-error text-error-foreground hover:bg-error/90',
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col items-end gap-3">
      {isExpanded && (
        <div className="flex flex-col gap-3 animate-slideUp">
          {secondaryActions?.map((action) => (
            <button
              key={action?.id}
              onClick={() => handleActionClick(action?.id)}
              className={`
                flex items-center gap-3 px-5 py-3 rounded-full shadow-lg
                ${getColorClasses(action?.color)}
                transition-all duration-250 ease-out
                hover:shadow-xl hover:scale-105
                focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3
              `}
              style={{ minWidth: '180px' }}
            >
              <Icon name={action?.icon} size={20} />
              <span className="text-sm font-medium">{action?.label}</span>
            </button>
          ))}
        </div>
      )}
      <div className="flex items-center gap-3">
        {isExpanded && (
          <button
            onClick={() => setIsExpanded(false)}
            className="quick-action-btn bg-muted text-foreground"
            aria-label="Close quick actions"
          >
            <Icon name="X" size={24} />
          </button>
        )}

        <button
          onClick={() => {
            if (isExpanded) {
              setIsExpanded(false);
            } else {
              handleActionClick(primaryAction?.id);
            }
          }}
          className={`quick-action-btn ${getColorClasses(primaryAction?.color)}`}
          aria-label={primaryAction?.label}
        >
          <Icon name={primaryAction?.icon} size={24} />
        </button>

        {!isExpanded && secondaryActions?.length > 0 && (
          <button
            onClick={() => setIsExpanded(true)}
            className="quick-action-btn bg-secondary text-secondary-foreground"
            aria-label="More actions"
          >
            <Icon name="MoreVertical" size={24} />
          </button>
        )}
      </div>
    </div>
  );
};

export default QuickActionPanel;